import { render } from "./SendOrderDeliveryModal.vue?vue&type=template&id=78d249db&scoped=true"
import script from "./SendOrderDeliveryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SendOrderDeliveryModal.vue?vue&type=script&setup=true&lang=js"

import "./SendOrderDeliveryModal.vue?vue&type=style&index=0&id=78d249db&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen2/autoringen2.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d249db"],['__file',"resources/themes/default/js/components/purchases/v2/SendOrderDeliveryModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78d249db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78d249db', __exports__)) {
    console.log('reload')
    api.reload('78d249db', __exports__)
  }
  
  module.hot.accept("./SendOrderDeliveryModal.vue?vue&type=template&id=78d249db&scoped=true", () => {
    console.log('re-render')
    api.rerender('78d249db', render)
  })

}


export default __exports__